import { IFilterSection } from 'shared/types/filter-section.interface';
import { ISortSection } from 'shared/types/sort-section.interface';
import { SortOrders } from 'shared/types/sort-order.enum';

export function createBrandSortSections(): ISortSection[] {
  return [createBrandNameSortSection('name')];
}

export function createRewardProductSortSections(): ISortSection[] {
  return [
    createBrandNameSortSection('brand__name'),
    {
      localizableName: 'rewards.ganasAmount',
      options: [
        {
          localizableName: 'common.sortOption.lowest',
          sortDirection: { sortBy: 'price', sortOrder: SortOrders.ASCEND }
        },
        {
          localizableName: 'common.sortOption.highest',
          sortDirection: { sortBy: 'price', sortOrder: SortOrders.DESCEND }
        }
      ]
    }
  ];
}

export function createRewardProductFilterSections(): IFilterSection[] {
  return [
    {
      name: 'Redeemable location',
      localizableName: 'common.sortOption.redeemableLocation',
      parameter_name: 'redeemable_in',
      checkboxModel: [
        {
          label: 'Mexico',
          localizableName: 'common.sortOption.mexico',
          value: 'mx',
          parameter_name: 'mx'
        },
        {
          label: 'United States',
          localizableName: 'common.sortOption.unitedStates',
          value: 'usa',
          parameter_name: 'usa'
        }
      ]
    }
  ];
}

function createBrandNameSortSection(sortBy: 'name' | 'brand__name'): ISortSection {
  return {
    localizableName: 'rewards.brand',
    options: [
      {
        localizableName: 'common.sortOption.A-Z',
        sortDirection: { sortBy, sortOrder: SortOrders.ASCEND }
      },
      {
        localizableName: 'common.sortOption.Z-A',
        sortDirection: { sortBy, sortOrder: SortOrders.DESCEND }
      }
    ]
  };
}
